module.exports = __webpack_public_path__ + "static/twitter-5604d7d00159d811f9eff4adc1ec74fe.svg";